import type { Tables } from "~/types/types.gen";

export default function useCurenciesSupabase() {
  const globalStore = useGlobalStore();

  const fetchCurrencies = async () => {
    if (globalStore.currencies) {
      return;
    }

    const { data, error } = await useSupabaseClient()
      .from("currencies")
      .select();

    const customSortedCurrenciesArray: Tables<"currencies">[] | undefined =
      data!.sort((a: Tables<"currencies">, b: Tables<"currencies">) => {
        if (a.code! === "EUR") return -1; // "EUR" comes before any other currency
        if (b.code! === "EUR") return 1;
        return a.code!.localeCompare(b.code!);
      });

    globalStore.currencies = customSortedCurrenciesArray;
  };

  return {
    fetchCurrencies,
  };
}
